import { NgModule } from '@angular/core';
import { ItmTextboxComponent } from './form-control/itm-textbox/itm-textbox.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ItmCheckboxComponent } from './form-control/itm-checkbox/itm-checkbox.component';
import { ItmButtonComponent } from './form-control/itm-button/itm-button.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ItmDatatableComponent } from './ui-component/itm-datatable/itm-datatable.component';
import { ItmStepperComponent } from './ui-component/itm-stepper/itm-stepper.component';
import { ItmDatepickerComponent } from './form-control/itm-datepicker/itm-datepicker.component';
import { ItmTimepickerComponent } from './form-control/itm-timepicker/itm-timepicker.component';
import { ItmAutocompleteComponent } from './form-control/itm-autocomplete/itm-autocomplete.component';
import { ItmComboboxComponent } from './form-control/itm-combobox/itm-combobox.component';
import { ItmRadioButtonComponent } from './form-control/itm-radio-button/itm-radio-button.component';
import { ItmTextareaComponent } from './form-control/itm-textarea/itm-textarea.component';
import { ItmTelephoneComponent } from './form-control/itm-telephone/itm-telephone.component';
import { ItmMapComponent } from './ui-component/itm-map/itm-map.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { ItmMapAutocompleteComponent } from './form-control/itm-map-autocomplete/itm-map-autocomplete.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AgmCoreModule } from '@agm/core';
import { MttokmPipe } from './_pipes/mttokm.pipe';
import { ItmDatatableServiceFiltersComponent } from './ui-component/itm-datatable-service-filters/itm-datatable-service-filters.component';
import { ItmFileuploadComponent } from './form-control/itm-fileupload/itm-fileupload.component';
import { ItmRequiredComponent } from './ui-component/itm-required/itm-required.component';
import { ItmDropdownMenuComponent } from './ui-component/itm-dropdown-menu/itm-dropdown-menu.component';
import { ItmModalComponent } from './ui-component/itm-modal/itm-modal.component';
import { ItmDatatableCustomerFiltersComponent } from './ui-component/itm-datatable-customer-filters/itm-datatable-customer-filters.component';
import { ItmConfirmModalComponent } from './ui-component/itm-confirm-modal/itm-confirm-modal.component';
import { ItmMapSelectionComponent } from './ui-component/itm-map-selection/itm-map-selection.component';
import { ItmDatatablePricelistFiltersComponent } from './ui-component/itm-datatable-pricelist-filters/itm-datatable-pricelist-filters.component';
import { ItmHelpCenterComponent } from './ui-component/itm-help-center/itm-help-center.component';
import { ItmComboboxMultipleComponent } from './form-control/itm-combobox-multiple/itm-combobox-multiple.component';
import { ItmCurrencyComponent } from './form-control/itm-currency/itm-currency.component';
import { InputNumberPipe } from './_pipes/inputnumber.pipe';
import { AgmDrawingModule } from '@agm/drawing';
import { ItmDatepickerModalComponent } from './ui-component/itm-datepicker-modal/itm-datepicker-modal.component';
import { ItmDatatableNetworkFiltersComponent } from './ui-component/itm-datatable-network-filters/itm-datatable-network-filters.component';
import { ItmSpinnerComponent } from './ui-component/itm-spinner/itm-spinner.component';

@NgModule({
	declarations: [
		ItmTextboxComponent,
		ItmCheckboxComponent,
		ItmButtonComponent,
		ItmDatatableComponent,
		ItmDatatableServiceFiltersComponent,
		ItmStepperComponent,
		ItmDatepickerComponent,
		ItmTimepickerComponent,
		ItmAutocompleteComponent,
		ItmComboboxComponent,
		ItmRadioButtonComponent,
		ItmTextareaComponent,
		ItmTelephoneComponent,
		ItmMapComponent,
		ItmMapAutocompleteComponent,
		MttokmPipe,
		InputNumberPipe,
		ItmDatatableServiceFiltersComponent,
		ItmFileuploadComponent,
		ItmRequiredComponent,
		ItmDropdownMenuComponent,
		ItmModalComponent,
		ItmDatatableCustomerFiltersComponent,
		ItmConfirmModalComponent,
		ItmMapSelectionComponent,
		ItmDatatablePricelistFiltersComponent,
		ItmHelpCenterComponent,
		ItmComboboxMultipleComponent,
		ItmCurrencyComponent,
		ItmDatepickerModalComponent,
		ItmDatatableNetworkFiltersComponent,
		ItmSpinnerComponent
	],
	imports: [
		CommonModule,
		TranslateModule.forChild({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		MatMomentDateModule,
		MatDatepickerModule,
		MatAutocompleteModule,
		MatSelectModule,
		NgxMaterialTimepickerModule,
		ReactiveFormsModule,
		AgmCoreModule.forRoot({
			apiKey: "AIzaSyA2Y1aMQhKW43EhC0qpOOD2H3rrhDhhknU",
			libraries: ["drawing"]
		}),
		AgmDrawingModule
	],
	providers: [
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
	],

	exports: [
		ReactiveFormsModule,
		CommonModule,
		ItmTextboxComponent,
		ItmCheckboxComponent,
		ItmButtonComponent,
		ItmDatatableComponent,
		ItmDatatableServiceFiltersComponent,
		ItmDatatableCustomerFiltersComponent,
		ItmStepperComponent,
		ItmDatepickerComponent,
		ItmAutocompleteComponent,
		ItmComboboxComponent,
		ItmRadioButtonComponent,
		ItmTextareaComponent,
		ItmTelephoneComponent,
		ItmFileuploadComponent,
		ItmMapComponent,
		ItmMapAutocompleteComponent,
		TranslateModule,
		NgxMaterialTimepickerModule,
		MttokmPipe,
		InputNumberPipe,
		ItmRequiredComponent,
		ItmDropdownMenuComponent,
		ItmModalComponent,
		ItmConfirmModalComponent,
		ItmMapSelectionComponent,
		ItmDatatablePricelistFiltersComponent,
		ItmHelpCenterComponent,
		ItmComboboxMultipleComponent,
		MatSelectModule,
		ItmCurrencyComponent,
		ItmDatepickerModalComponent,
		ItmDatatableNetworkFiltersComponent,
		ItmSpinnerComponent,
		ItmTimepickerComponent
	]
})
export class SharedModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}